var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"innerClass":"large","name":"imageDisplay","closeOutside":false},on:{"open":_vm.openEvent,"close":_vm.closeEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }